/**
 * Created by glopez on 13/06/17.
 */
import {getInstance as getDataSources} from 'datasources';

import {
    ActiveViewStatuses,
    setActiveViewStatus
} from 'store/actions/viewtree';

// Action types
const Actions = {
        REQUEST_SERIES_PAGE: 'REQUEST_SERIES_PAGE',
        RECEIVE_SERIES_PAGE: 'RECEIVE_SERIES_PAGE',
        SET_BOOKMARKS: 'SET_BOOKMARKS'
    };

/**
 * Request episodes action.
 *
 * @param {number} seriesId - Series id.
 * @returns {Object} Action.
 */
function requestSeriesPage (seriesId) {
    return {
        type: Actions.REQUEST_SERIES_PAGE,
        seriesId
    };
}

/**
 * Receive episodes action.
 *
 * @param {Object} series - Series asset.
 * @param {Object} episodes - Series episodes.
 * @returns {Object} Action.
 */
function receiveSeriesPage (series, episodes) {
    return {
        type: Actions.RECEIVE_SERIES_PAGE,
        series,
        episodes
    };
}

/**
 * Sets bookmarks for series page.
 *
 * @param {Object} bookmarks - Series episodes bookmarks.
 * @returns {Object} Action.
 */
function setBookmarks (bookmarks) {
    return {
        type: Actions.SET_BOOKMARKS,
        bookmarks
    };
}

/**
 * Receive series page data.
 *
 * @param {number} seriesId - Series id.
 * @returns {Promise} Response to the request of data.
 */
function fetchSeriesPage (seriesId) {
    let dataSources = getDataSources();

    return (dispatch) => {
        dispatch(requestSeriesPage(seriesId));

        return dataSources.getSeriesPage(seriesId)
            .then(data => {
                dispatch(receiveSeriesPage(data.series, data.episodes));
                dispatch(setActiveViewStatus(ActiveViewStatuses.READY));
                return data;
            })
            .then(data => {
                let {episodes} = data,
                    episodesIds = episodes.map((episode) => {
                        return episode.id;
                    });

                if (episodesIds) {
                    return dataSources.getBookmarks(episodesIds).then(bookmarks => {
                        dispatch(setBookmarks(bookmarks));
                        return bookmarks;
                    });
                }
                return Promise.resolve();
            });
    };
}

export {
    Actions,
    requestSeriesPage,
    receiveSeriesPage,
    fetchSeriesPage
};


// WEBPACK FOOTER //
// ./src/js/store/actions/pages/series.js